import React, { useState, useEffect, useRef } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Spinner} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import { Container } from 'reactstrap';
import './ConsoleBind.css';
import QrCodeScannerModal from "../modal/qrCodeScannerModal/qrCodeScannerModal";
import {useTranslation} from "react-i18next";
import { logger } from '../../utils/logger';

function ConsoleBind() {
    const { t } = useTranslation(['modem']);
    const protocol = new signalR.JsonHubProtocol();

    const [hubBind, setHubBind] = useState(hubConnect);

    const [pressedBindInfo, setPressedBindInfo] = useState(false);
    const [modemNotOnlineInfo, setModemNotOnlineInfo] = useState(<></>);
    const [bindTime, setBindTime] = useState(40);
    const [codeValue, setCodeValue] = useState('');
    const [isQrCodeScannerModalOpen, setQrCodeScannerModalOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const onChangeCodeInput = (event) => {
        event.preventDefault();
        setCodeValue(event.target.value);
    };

    const onScanQrCodeClick = () => {
        setQrCodeScannerModalOpen(true);
    }

    const onDecode = (decodedText) => {
        setCodeValue(decodedText.match("IMEI:([0-9]*)")[1]);
        setQrCodeScannerModalOpen(false);
    }

    const timerRef = useRef(null);


    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        connection.on('BindIsOk', (message) => {logger.debug("bind is ok. imei:" + message.imei); BindIsOk(message)});
        connection.start();
        return connection;
    }

    function BindIsOk(){
        window.location.reload();
    }

    useEffect(() => {
        logger.debug("bind mount");
        startTimer();
      }, []);

    useEffect(() => {
        setErrorMsg("");
    }, [codeValue]);

    // таймер срабатывает по клику
    const startTimer = () => {
      timerRef.current = setTimeout(() => {
        setPressedBindInfo(false);
      }, bindTime * 1000);
    }

    useEffect(() => {
        return () => {
            clearTimeout(timerRef.current); // очистка таймера
            logger.debug("bind.js unmount");
            hubBind.stop();
        };
    }, []);

    function submitFormBindModem(event){
        event.preventDefault()
        logger.debug(event.target[0].value)
    
        axios.post('api/drone/bindModem', {imei: event.target[0].value})
            .then(response => {
                logger.debug(response); 
                if(response.data.state == "NotPressedBind"){
                    setPressedBindInfo(true);
                    logger.debug("bind time: " + response.data.bindTime);
                    setBindTime(response.data.bindTime);
                    clearTimeout(timerRef.current);
                    startTimer();
                }

                if(response.data.state == "Ok") {
                    window.location.reload();
                }
            })
            .catch((error) => {
                if(error.response.status === 400){
                    setErrorMsg(error.response.data);
                }
            });
    }

    return(
        <div className='console-bind'>
            <div className='addition-white normal-text bind-label'>{t('adding_device')}</div>

            <Form onSubmit={submitFormBindModem}>
                <Form.Control
                    type="text"
                    placeholder="IMEI"
                    value={codeValue}
                    onChange={onChangeCodeInput}
                />

                {(pressedBindInfo == false) ?
                    <div className='bind-buttons'>
                      <Button variant="primary" type="submit">
                          Bind
                      </Button>
                      <Button variant="light" onClick={onScanQrCodeClick}>
                          Scan QR-Code
                      </Button>
                      <div className='bind-error-text'>
                        {t(errorMsg)}
                      </div>
                    </div> :
                    <div className='bind-spinner-info'>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <div>{t('press_bind_button_1')}{bindTime}{t('press_bind_button_2')}</div>
                    </div>
                }
                {modemNotOnlineInfo}
            </Form>
            <QrCodeScannerModal
                show={isQrCodeScannerModalOpen}
                onDecode={onDecode}
                onClose={() => setQrCodeScannerModalOpen(false)}
            />
        </div>
    )
}

export default ConsoleBind;